import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserNavComponent } from './user-nav.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LoadingModule } from '@schoolbelle/common/loading';

@NgModule({
  declarations: [UserNavComponent],
  imports: [
    CommonModule, 
    BsDropdownModule.forRoot(), 
  ],
  exports: [UserNavComponent]
})
export class UserNavModule {}
